// ts-prune-ignore-next
export const environment = {
  production: true,
  buildVersion: "251106-3",
  baseUrl: "https://test-app.astrobin.com",
  classicBaseUrl: "https://www.astrobin.com",
  classicApiUrl: "https://www.astrobin.com",
  cdnUrl: "https://cdn.astrobin.com",
  wsUrl: "wss://beta.astrobin.com",
  sentryKeys: ["16bc7458d1ea4101a899a85a85929f7c", "o4503907479519232", "4503907579002880"],
  ckeditorTimestamp: "20250724.1",
  authSessionTimeout: 1200,
  turnstileSiteKey: "0x4AAAAAAA81Q5_THN3cKjKR"
};
